(ns pfo.signature.component
  (:require
   [reagent.core :as reagent :refer [atom track!] :refer-macros [with-let]]
   [cljs-time.format :as time-format]
   [cljs-time.coerce :as time-coerce]
   ["react-select/creatable" :default CreatableSelect]
   ["hellosign-embedded" :as HelloSign]
   [pfo.api :as api :refer [process-error]]
   [applied-science.js-interop :as j]
   [pfo.auth.model :as auth-model]
   [pfo.common.component :as common]
   [pfo.widget.pdf :refer [pdf-view]]
   [pfo.controller :as controller :refer [subscribe]]
   [clojure.string :as str]
   [pfo.tz :as tz]
   [pfo.form :refer [checkbox checked?]]
   [pfo.util :as util]
   [pfo.state :as state]
   [promesa.core :as p]))

(defn valid-email? [email]
  (boolean (re-matches #"^[^\s@]+@[^\s@]+\.[^\s@]+$" email)))

(defn recipient-picker [{:keys [disabled
                                add-signer-form-show-atom]} selected family-id]
  (with-let [selected-set (track! (fn [] (set (map :value @selected))))
             options (atom nil)
             current-select-input-value (atom "")
             _ (controller/dispatch :permitted-users :load
                 {:collection-ids [family-id]
                  :include-contacts true
                  :include-emails true
                  :on-success (fn [users]
                                (reset! options
                                  (map (fn [user]
                                         {:value (:id user)
                                          :name (auth-model/get-full-name user)
                                          :label (str (auth-model/get-full-name user)(when (:email user) (str " <" (:email user) ">")))
                                          :internal true
                                          :email (:email user)
                                          :contact (:is_contact user)})
                                    (sort-by :last_name
                                      (filter (fn [user]
                                                (and
                                                  (or (seq (:first_name user)) (seq (:last_name user)))
                                                  (seq (:email user))))
                                        users)))))})
             pending-input (atom nil)
             name-input (atom "")
             email-input (atom "")
             name-ref (atom nil)]

    (let [form-valid? (and (not (str/blank? @name-input))
                        (valid-email? @email-input))]
      [:div
       [:div.u-flex.u-flex--justify-content-center
        [:> CreatableSelect
         {:isMulti true
          :options (clj->js (remove #(contains? @selected-set (:value %))
                              (if (not-empty @current-select-input-value)
                                @options
                                (filter (comp not :contact) @options))))
          :value nil
          :isDisabled disabled
          :onChange #(swap! selected conj (first (js->clj % :keywordize-keys true))) 

          :onInputChange (fn [value action]
                           (reset! current-select-input-value value)
                           value)
          :onCreateOption
          (fn [input]
            (reset! pending-input input)
            (if (valid-email? input)
              (do
                (reset! name-input "")
                (reset! email-input input))
              (do
                (reset! name-input input)
                (reset! email-input "")))
            (reset! add-signer-form-show-atom true)
            ;; Delay autofocus slightly to ensure DOM is ready
            (js/setTimeout
              #(when-let [el @name-ref] (.focus el))
              50))
          :formatCreateLabel (fn [input] (str "Add \"" input "\""))
          :placeholder "Enter signer"
          :styles (clj->js
                    {:multiValue
                     (fn [base data]
                       (let [internal (get-in (util/to-clj data) [:data :internal])]
                         (j/assoc! base :backgroundColor (if internal "#89e2f4" "#fff3cd"))))
                     :container
                     (fn [base _]
                       (j/assoc! base :width "70%"))})}]]

       (when @add-signer-form-show-atom
         [:div
          [:div {:style {:margin-top "10px"
                         :padding "10px"
                         :background "#f9f6f3"
                         :border "1px solid #eee"}}


           [:div.signature-external-row [:label "Name: "]
            [:input {:type "text"
                     :ref (fn [el] (reset! name-ref el))
                     :value @name-input
                     :on-change #(reset! name-input (.. % -target -value))
                     :on-key-down
                     (fn [e]
                       (when (= (.-key e) "Enter")
                         (.preventDefault e)
                         (when form-valid?
                           (let [new-recipient {:label (str @name-input " <" @email-input ">")
                                                :value @email-input
                                                :name @name-input
                                                :internal false}]
                             ;; Add to options and selected
                             (swap! options conj new-recipient)
                             (swap! selected conj new-recipient)
                             ;; Reset form
                             (reset! name-input "")
                             (reset! email-input "")
                             (reset! add-signer-form-show-atom false)))))}]]

           ;; Email input
           [:div.signature-external-row [:label "E-mail: "]
            [:input {:type "text"
                     :value @email-input
                     :on-change #(reset! email-input (.. % -target -value))
                     :on-key-down
                     (fn [e]
                       (when (= (.-key e) "Enter")
                         (.preventDefault e)
                         (when form-valid?
                           (let [new-recipient {:label (str @name-input " <" @email-input ">")
                                                :value @email-input
                                                :name @name-input
                                                :internal false}]
                             (swap! options conj new-recipient)
                             (swap! selected conj new-recipient)
                             (reset! name-input "")
                             (reset! email-input "")
                             (reset! add-signer-form-show-atom false)))))}]]]
          [:div
           [:button {:style {:margin-top "5px"
                             :font-size "0.9rem"}
                     :disabled (not form-valid?)
                     :on-click
                     (fn []
                       (when form-valid?
                         (let [new-recipient {:label (str @name-input " <" @email-input ">")
                                              :value @email-input
                                              :name @name-input
                                              :internal false}]
                           (swap! options conj new-recipient)
                           (swap! selected conj new-recipient)
                           (reset! name-input "")
                           (reset! email-input "")
                           (reset! add-signer-form-show-atom false))))}
            "Add Signer"]
           " "
           [:button {:style {:margin-top "5px"
                             :font-size "0.9rem"}
                     :on-click
                     (fn []
                       (reset! name-input "")
                       (reset! email-input "")
                       (reset! add-signer-form-show-atom false))}
            "Cancel"]]] )])))



(defn recipient-row [{:keys [remove-signer
                             update-signer
                             can-add-contact?]} signer index error? set-order]
  [:div.signature-recipient {:data-value (:value signer)}
   (when set-order
     [:span.signature-drag-handle "⠿"])

   [:div.signature-recipient-content
    [:div.signature-title (when set-order (str (inc index) ". ")) (:name signer)]

    [:div.signature-row
     [:div.signature-input-group
      [:label {:for (str "name-" index)} "Name"]
      [:input (merge
                {:type "text"
                 :id (str "name-" index)
                 :on-change (fn [ev] (update-signer (assoc signer :name (util/event-value ev))))
                 :value (:name signer)
                 :class (when error? "signature-error")}
                (when (:internal signer) {:disabled :disabled}))]
      [:div.signature-signar-type.u-color--secondary.u-margin-top--xs.u-margin-left--xs [:emph (cond
                                                                                                 (not (:internal signer)) "External"
                                                                                                 (:contact signer) "Contact"
                                                                                                 :else "User")]]
      (when error?
        [:div.signature-error-text "Required"])]

     [:div.signature-input-group
      [:label {:for (str "email-" index)} "Email address"]
      [:input (merge
                {:type "email"
                 :id (str "email-" index)
                 :required "required"
                 :on-change (fn [ev] (update-signer (assoc signer :value (util/event-value ev))))
                 :value (if (:internal signer)
                                (:email signer)
                                (:value signer))}
                (when (:internal signer) {:disabled :disabled}))]
      (when (and
              can-add-contact?
              (not (:internal signer)))
        [:label.u-color--secondary.u-margin-top--xs.u-margin-left--xs
         [:input {:type :checkbox
                  :checked (:save-contact signer)
                  :on-change #(update-signer (assoc signer :save-contact (checked? %)))}]
         [:emph {:style {:font-weight :normal}} "Save as new Contact"]])]]]

   [:div.signature-menu-button {:on-click (util/handler
                                            (fn [](remove-signer index)))} "X"#_"⋯"]])

(defn dropbox-sign-signers [{:keys [next-cb disabled has-signers *ordered]
                             :as options} *selected family-id]
  (with-let [add-signer-form-show (atom false)
             sortable-elem (atom nil)
             family (subscribe :collection-details)
             _ (controller/dispatch :collection-details :clear)
             _ (controller/dispatch :collection-details :load {:collection-id family-id})]
    [:div.u-margin-bottom {:style {:padding-top "1px"}}
     [:div.signature-logos 
      [:img {:src "/static/img/brand/ipaladin-logo-blue.png"
             :alt "iPaladin Logo"
             :style {:height "60px"}}]
      [:div.u-font-size--xsmall "Powered by"]
      [:img {:src "/static/img/brand/dropbox-sign.png"
             :alt "Dropbox Sign"
             :style {:height "20px"}}]]
     [:h1.u-text-align--center.u-margin-top "Request a Signature"] 
     [:h3.u-text-uppercase.u-text-align--center {:style {:margin-top :3.5em}} "Add signers"]
     [:p.u-text-align--center.u-margin-top
      "Select from list of all " (:name @family) " users" [:br]
      "-or-" [:br]
      "Start typing to search iPaladin contacts" [:br]
      "-or-" [:br]
      "Type a complete email address to add anyone else"]
     
     [:div.u-margin-top
      [recipient-picker (assoc options
                          :add-signer-form-show-atom add-signer-form-show) *selected family-id]
      [:div.u-margin-top
       [:div {:ref
              (fn [elem]
                (when elem (reset! sortable-elem elem)
                      (.sortable (js/$ elem) #js
                        {:handle ".signature-drag-handle"
                         :update (fn [_ ui]
                                   (let [new-index (-> ui .-item .index)
                                         value (-> ui .-item (.attr "data-value"))
                                         indexed (map-indexed vector (remove #(= (str (:value %)) value) @*selected))
                                         item (first (filter #(= (str (:value %)) value) @*selected))
                                         partitioned (partition-by (fn [[index _]] (= index new-index)) indexed)
                                         [before match after] (if (zero? new-index) (concat [[]] partitioned) partitioned)
                                         reordered (vec
                                                     (concat
                                                       (map second before)
                                                       [item]
                                                       (map second match)
                                                       (map second after)))]
                                     (.sortable (js/$ elem) "cancel")
                                     (reset! *selected reordered)))})))}
        (doall
          (map-indexed
            (fn [index signer]
              [recipient-row {:remove-signer (fn [index]
                                               (swap! *selected util/vec-remove index)
                                               (when (< (count @*selected) 2)
                                                 (reset! *ordered false)))
                              :update-signer (fn [signer]
                                               (swap! *selected assoc index signer))
                              :can-add-contact? (auth-model/is-user-family-admin family-id)} signer index false @*ordered])
            @*selected))]
       
       (when (> (count @*selected) 1)
         [:div [:label [checkbox *ordered] " Set signer order"]])

       #_[:button.signature-add-btn
          [:span.signature-icon "👤"] "Add a Signer"]]

      (when (and (not disabled) has-signers (not @add-signer-form-show))
        [:div.u-margin-top--xs.o-flex-align--right
         [:button
          (merge
            {:style {:font-size "0.9rem"}
             :on-click (util/handler
                         (fn []
                           (next-cb)
                           (swap! state/modals assoc-in
                             [:signature-create :options :modal-class]
                             :c-signature-create)))}
            (when (some (fn [signer] (and
                                       (not (:internal signer))
                                       (not (valid-email? (:value signer))))) @*selected)
              {:disabled :disabled})) "Next"]])]]))

(defn dropbox-sign-create [{:keys [next-cb
                                   *ordered
                                   close-cb]} step selected-signers]
  (with-let [html-elem (atom nil)]
    [:div {:style {:height "100%"}}
     [:h2 "Place signature fields"]
     [:div {:style {:height "100%"}
            :ref (fn [elem]
                   (when-not @html-elem
                     (reset! html-elem elem)
                     (->>
                       (api/ajaxp (str "/ext/signature/?occurrence_id=" (:id step))
                         {:method :post
                          :body (util/make-params-with-maps
                                  {:external_signer (vec (for [signer selected-signers
                                                               :when (not (:internal signer))] {:name (:name signer)
                                                                                                :email (:value signer)
                                                                                                :contact_add (boolean (:save-contact signer))} ))
                                   :internal_signer_id (mapv :value (filter :internal selected-signers))
                                   :timezone (tz/get-user-timezone)
                                   :ordered @*ordered})})
                       (p/map (fn [resp]
                                (controller/dispatch :signature-status :load [{} {:occurrence_id (:id step)}])
                                (let [client (HelloSign.)]
                                  (.on client "close" (fn [] (some-> close-cb (apply []))))
                                  (.open client (:sign_url resp) #js{:clientId (:client_id resp)
                                                                     :skipDomainVerification js/DROPBOX_SIGN_TEST_MODE
                                                                     :container elem}))))
                       (process-error))))}]]))

(defn dropbox-sign-modal [step family-id]
  (with-let [*step (atom :signers)
             *selected-signers (atom [])
             *ordered (atom false)]
    [:div {:style {:height "100%"}}
     (case @*step
       :signers [dropbox-sign-signers {:next-cb #(reset! *step :create)
                                       :*ordered *ordered
                                       :disabled (not= :signers @*step)
                                       :has-signers (seq @*selected-signers)} *selected-signers family-id]
       :create [dropbox-sign-create {:close-cb #(common/hide-modal :signature-create)
                                     :*ordered *ordered} step @*selected-signers])]))


(defn sign [token]
  (with-let [sign-url-info (atom nil)
             message (atom "Please wait..")
             _ (controller/dispatch :signature :sign {:token token

                                                      :on-success (fn [response] (reset! sign-url-info response)
                                                                    (let [client (HelloSign.)]
                                                                      (.on client "cancel" #(reset! message "Signture canceled"))
                                                                      (.on client "error" #(reset! message "Signing error. Please try again later"))
                                                                      (.on client "finish" #(reset! message "Signature complete"))
                                                                      (.open client (:sign_url @sign-url-info) #js{:clientId (:client_id @sign-url-info)
                                                                                                                   :skipDomainVerification js/DROPBOX_SIGN_TEST_MODE})
                                                                      (reset! message "")))
                                                      :on-error (fn [e]
                                                                  (let [err (-> e :response :body)]
                                                                    (if (= 410 (:status e))
                                                                      (reset!
                                                                        message
                                                                        (case (get-in e [:response :body :type])
                                                                          "token_expired" "The signature link has expired"
                                                                          "signature_canceled" [:span "This signature request has been canceled by the Sender. Please contact " (get-in e [:response :body :sender :name])
                                                                         " (" [:a {:href (str "mailto:" (get-in e [:response :body :sender :email]))} (get-in e [:response :body :sender :email])] ") for more information."])
                                                                        
                                                                        #_[:span
                                                                         "This link has expired. Please contact the Sender, " (get-in e [:response :body :name])
                                                                         " (" [:a {:href (str "mailto:" (get-in e [:response :body :email]))} (get-in e [:response :body :email])] ") "
                                                                         " to obtain another copy of the document"])
                                                                      (if (= "already_signed" (:type err))
                                                                        (reset! message (:message err))
                                                                        (throw e)))))})]
    [:div.u-text-align--center @message "."]))

(defn document-modal [token]
  (let [url (str "/signature/download/" token "/")
        show-pdf (atom false)]
    (->>
      (api/ajaxp "" {:uri (str url "?check=1") }) 
      (p/map (fn [response]
               (case (:action response)
                 "download" (reset! show-pdf true)
                 "redirect" (util/set-location (:location response)))))
      (process-error))
    (fn [_]
      (when @show-pdf
        [pdf-view {:load-pdf (fn [set-pdf] (set-pdf url))
                   :multi-page true}]))))

(defn view [token]
  (with-let [_ (common/show-modal :signature-document-modal [document-modal token] {:close-disable true})]
    [:div [common/modals]]))

(def signature-time-format (time-format/formatter "M/d/yyyy h:mm a"))

(defn format-timestamp [ts]
  (time-format/unparse signature-time-format (tz/to-browser-time (time-coerce/from-date (js/Date. (* 1000 ts))))))

(defn signature-details [options sgn]
  (with-let [message-show (atom false)]
    [:div
     [:h2.u-flex "Signature details"]
     [:form.c-form--edit.c-form--edit--spreaded
      (let [signers (get-in sgn [:provider_info :signatures])
            signer-count (count signers)
            ordered (:ordered sgn)
            signers-info (:signers sgn)
            first-pending-signer-info (first (filter #(= (:status %) "p") signers-info))
            show-remind-button? (fn [signer-info]
                                  (if ordered
                                    (= signer-info first-pending-signer-info)
                                    (= (:status signer-info) "p")))]
        [:p
         [:dl
          [:dt "Created:"]
          [:dd (if (:provider_info sgn)
                 (format-timestamp (get-in sgn [:provider_info :created_at]))
                 (util/date-reformat (:created_at sgn) #(time-format/unparse signature-time-format %)))]]
         (when (:status sgn)
           [:dl
            [:dt "Status:"]
            [:dd (case (:status sgn)
                   "c" "Complete"
                   "n" "Initiated"
                   "xp" "Pending Cancellation"
                   "x" "Cancelled"
                   "Pending Signature")]])
         [:table
          [:tbody
           (doall
            (for [[idx signer] (map-indexed vector signers)
                  :let [signer-info (nth signers-info idx nil)]]
              [:tr.u-vertical-align--middle
               [:td.u-border-none
                [:dl.u-margin-top--none
                 [:dt "Signer " (inc idx) " of " signer-count ": " (:signer_name signer) " (" (:signer_email_address signer) ")"]
                 [:dd "Status: " (str/capitalize (str/replace (:status_code signer) #"_" " "))]
                 (when (not= 0 (:last_viewed_at signer))
                   [:dd "Last viewed at: " (format-timestamp (:last_viewed_at signer))])
                 (when (not= 0 (:signed_at signer))
                   [:dd "Signed at: " (format-timestamp (:signed_at signer))])
                 (when (:last_notification_time signer-info)
                   [:dd "Last notification:"
                    (format-timestamp (:last_notification_time signer-info))
                    " ("
                    ({"r" "reminder"
                      "i" "initial"
                      "c" "complete"} (:last_notification_type signer-info))
                    ")"])]]
               [:td.u-border-none
                (when (show-remind-button? signer-info)
                  [:button {:on-click (util/handler
                                       (fn []
                                         (controller/dispatch :signature :remind {:signer-id (:id signer-info)})))}
                   "Remind"])]]))]]
         [:div
          [:dl [:dt [:a {:href "#"
                         :on-click (util/handler #(swap! message-show not))} (if @message-show "▾" "▸") " Message"]]
           (when @message-show
             [:dd
              [:p.u-margin-bottom "Subject: " (get-in sgn [:provider_meta :message_subject])]
              [:p.u-preserve-whitespace (get-in sgn [:provider_meta :message_content])]])]]
         [:div
          [:button {:on-click (util/handler (fn [] (swap! state/modals update :signature-details :enabled :false))) } "Close"] " "
          (when (= (:status sgn) "c")
            [:form {:method :post
                    :style {:display :inline}
                    :action (str "/download/occurrence/" (:occurrence_id sgn) "/signature/audit/")}
             [:input {:type :hidden
                      :name :key
                      :value (:download_key sgn)}]
             [:input {:type :hidden
                      :name :attachment
                      :value "yes"}]
             [:button "Audit File"] " "])
          (when (and (:status sgn) (not (contains? #{"c" "x" "xp"} (:status sgn))))
            [:<>
             (when (> (count (filter #(not= (:status_code %) "signed") signers)) 1)
               [:button {:on-click (util/handler
                                    (fn []
                                      (if ordered
                                        (controller/dispatch :signature :remind {:signer-id (:id first-pending-signer-info)})
                                        (controller/dispatch :signature :remind-all {:signature-id (:id sgn)}))))}
                "Remind All"])
             " "
             [:button {:on-click (util/handler
                                  (fn []
                                    (when (js/confirm "Are you sure you want to cancel the signature process?")
                                      (->>
                                       (api/ajaxp (str "/ext/signature/cancel/?occurrence_id=" (:occurrence_id sgn))
                                                  {:method :post})
                                       (p/map (fn [_]
                                                (swap! state/modals update :signature-details :enabled :false)
                                                (controller/dispatch :signature-status :load [{} {:occurrence_id (:occurrence_id sgn)}])))
                                       (process-error)))))}
              "Cancel signature"]])]])]]))
